import { locationIdFormat } from "@redotech/redo-inventory-id";
import * as z from "zod";

const LocationSchema_ = z.object({
  id: locationIdFormat.schema,
  name: z.string(),
  street_1: z.string().nullable(),
  street_2: z.string().nullable(),
  city: z.string().nullable(),
  state: z.string().nullable(),
  postal_code: z.string().nullable(),
  country: z.string().nullable(),
  external_id: z.string().nullable(),
});

export const LocationSchema: z.ZodType<Location> = LocationSchema_;
export interface Location extends z.infer<typeof LocationSchema_> {}

export const getLocations = {
  name: "getLocations" as const,
  input: z.object({}),
  output: z.object({ locations: z.array(LocationSchema) }),
};
